exports.plural = int => {
    // Note that we can interpret this return as a boolean, as whether or not
    // a value is plural. Useful for when you need to conjugate a different word
    // according to a plural context e.g. were vs. was
    return int > 1 ? "s" : "";
};

exports.capitalize = str => str.replace(/^./, c => c.toUpperCase());



// WEBPACK FOOTER //
// ./src/utils/content-helpers.js